import * as React from 'react';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

export type Props = {
  onClick: () => Promise<string>;
  disabled?: boolean;
  inactive?: boolean;
  fontWeight?: 'bold' | 'semiBold';
  label: string;
  buttonType?: ButtonType;
  type?: 'button' | 'submit';
};

const ProgressButtonWrapper: React.FC<React.PropsWithChildren<Props>> = ({ label, ...props }) => (
  <ProgressButton {...props}>{label}</ProgressButton>
);

export default {
  ReactComponent: ProgressButtonWrapper,
  bindings: {
    onClick: '&',
    disabled: '<?',
    inactive: '<?',
    fontWeight: '@?',
    label: '@',
    buttonType: '@?',
    type: '@?',
  },
};
